var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareOffOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eab308",
    d: "M22.1 21.5L2.4 1.7L1.1 3l7.8 7.8C5.4 12.9 3.7 16.4 3 20c2.3-3.3 5.6-4.9 10-5.1l1 1V19l1.6-1.6l5.2 5.3M8.3 13.8c.64-.58 1.35-1.09 2.1-1.5l.9.8m2.9-2.1l-1.7-1.7L14 9V5l7 7l-2.9 2.9l-1.4-1.4l1.5-1.5L16 9.8v.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOffOutline);
export default __webpack_public_path__ + "static/media/share-off-outline.f08a8955eced53e5734900003d881e7e.svg";
export { ForwardRef as ReactComponent };